<td class="ps-1">
	@if (rule.ruleSource === ruleSources.Amount) {
		Amount
	} @else {
		Contact
	}
</td>
<td>
	{{ruleTypeName}}
</td>
<td>
	@if (rule.ruleType === ruleTypes.FieldValue) {
		{{picklistLabel}}
	}
</td>
<td>
	@if (rule.ruleType === ruleTypes.FieldValue) {
		<span [innerHTML]="picklistValueLabel"></span>
	} @else if (rule.ruleType === ruleTypes.Record) {
		{{contactName$ | async}}
	} @else if (rule.ruleType === ruleTypes.Template) {
		{{templateName}}
	} @else if (rule.ruleType === ruleTypes.TemplateGroup) {
		{{templateGroupName}}
	}
</td>
<td class="p-1">
	<div class="hover-icons text-end">
		<button class="btn btn-icon btn-info btn-sm me-2" (click)="editRule()" data-cy="editTemplate"
			title="Edit Rule"><i class="fal fa-pencil fa-sm"></i></button>
		<button class="btn btn-icon btn-remove btn-sm me-1" data-cy="deleteTemplate" title="Delete Rule"
			(click)="deleteRule()"><i class="fal fa-trash-can fa-sm"></i></button>
	</div>
</td>